import React from 'react';
import { parseContentstackComponent } from '../../parseUtils';
import { css } from "@emotion/core"
import { mq } from "../mixins"
import * as Mixins from '../mixins';


const twoColumnWrapper = css`
  ${Mixins.dFlex}
  ${Mixins.flexDirection('column')}
  ${Mixins.alignItems('center')}


  ${mq("tablet")}  {
    ${Mixins.flexDirection('row')}
  }

  .inner_content_container {
    ${mq("tablet")} {
      width: 50%;
    }
  }

  .staggeredImageText__block {
      ${Mixins.flexDirection('column')}
  }

  .quote-block{
    .container{
      ${Mixins.flexDirection('column')}
    }
    .quote-block__content{
      width: 100%;
    }
    .quote-block__quote{
      ${Mixins.alignSelf("normal")}
    }
  }

  &.light {
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    p,
    a {
      color: #000;
    }

  }
  &.dark{
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    p,
    a {
      color: #fff;
    }
  }
`

const TwoColumnContent = (props) => {
  return (
    <div 
      className={`two_column_content_container ${props.color_theme}`}
      css={twoColumnWrapper}
    >
      <div className="inner_content_container">
        {parseContentstackComponent(props.left_entry[0])}
      </div>
      <div className="inner_content_container">
        {parseContentstackComponent(props.right_entry[0])}
      </div>
    </div>
  );
}

export default TwoColumnContent;